// Wywołania API panelu Subiekta.
//
// Nie korzystamy z globalnego interceptora axiosa (authAxiosPlugin w src/store/index.js),
// bo jest ZAKOMENTOWANY w liście pluginów store'a — i celowo tego nie zmieniam: dokłada
// on `x-app-id` do KAŻDEGO żądania axios w aplikacji, także do obcych domen, co potrafi
// wywrócić preflight CORS. Włączenie go dla panelu zmieniałoby zachowanie całego systemu.
//
// Endpointy /subiekt/* jako pierwsze w tym API wymagają checkAccess, więc nagłówki
// dokładamy tutaj — w jednym miejscu, zamiast w siedemnastu wywołaniach.
import axios from 'axios';
import { auth } from '@/firebase/gfbconf';

// Ta sama wartość, której pilnuje checkAccess po stronie funkcji (WEB_APP_ID).
const APP_ID = 'janart_6692046951778248';

export async function subiektPost(apiLink, sciezka, dane = {}) {
  const naglowki = { 'x-app-id': APP_ID };

  // Token bierzemy świeży przy każdym żądaniu — getIdToken sam odnawia wygasły.
  // Gdy sesji nie ma, wysyłamy bez niego: backend odpowie zrozumiałym komunikatem,
  // a nie ciszą, i użytkownik zobaczy, że musi się zalogować ponownie.
  const uzytkownik = auth.currentUser;
  if (uzytkownik) {
    try {
      naglowki.Authorization = `Bearer ${await uzytkownik.getIdToken()}`;
    } catch (blad) {
      console.log('Nie udało się pobrać tokenu:', blad);
    }
  }

  return axios.post(`${apiLink}${sciezka}`, dane, { headers: naglowki });
}
